import React from "react";
import { SIDEBAR_ITEMS } from "../../utils";

function Sidebar() {
  return (
    <div style={{ width: "100%" }}>
      <div className="card-body">
        {SIDEBAR_ITEMS.map((item) => (
          <a
            key={item.key}
            href="#"
            className="btn btn-primary btn-block"
            draggable
          >
            {item.name}
          </a>
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
